import React from 'react';
import './App.css';
import Site from './components/Site';

function App() {
  return <Site />;
}

export default App;
